<template>
  <div class="comments-project">
    <b-row v-if="cmsType == 'post'">
      <b-col cols="12" md="8">
        <h5>{{ cmsData.title }}</h5>
        <span style="margin-bottom:10px !important;display:block;">
          {{ cmsData.source ? `${cmsData.source} / ` : "未知 / " }}
          {{ getDate(cmsData.createTime) }}
        </span>
        <p class="maxLength-text-2">{{ cmsData.digest }}</p>
        <div>
          <div class="projects-contexts">
            <a @click="goDetails(cmsData.id)">
              查看详情
              <i></i>
            </a>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="4">
        <img
          :src="getImgUrl(cmsData.photoUrl)"
          @click="goDetails(cmsData.id)"
        />
      </b-col>
    </b-row>
    <b-row v-if="cmsType == 'project'">
      <b-col cols="12" md="8">
        <h5>{{ cmsData.name }}</h5>
        <span style="margin-bottom:10px !important;display:block;">{{
          getDate(cmsData.createTime)
        }}</span>
        <p class="maxLength-text-2" v-html="cmsData.desc"></p>
        <div>
          <div class="projects-contexts">
            <a @click="goDetails(cmsData.id)">
              查看详情
              <i></i>
            </a>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="4">
        <img
          :src="getImgUrl(cmsData.photoUrl)"
          @click="goDetails(cmsData.id)"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import Api from "@/apis";
export default {
  data() {
    return {
      cmsData: {}
    };
  },
  props: {
    cmsType: {
      type: String,
      default: "post"
    },
    cmsId: {
      type: Number
    }
  },
  watch: {
    cmsId: {
      deep: true,
      handler: function() {
        this.getListData();
      }
    }
  },
  mounted() {
    this.getListData();
  },
  methods: {
    async getListData() {
      try {
        if (this.cmsType == "post") {
          const cms = await Api.CMS.getCmsDeatil(this.cmsId);
          this.cmsData = cms;
        }
        if (this.cmsType == "project") {
          const project = await Api.Project.getProjectId(this.cmsId);
          this.cmsData = project;
        }
      } catch (e) {
        console.log(e);
      }
    },
    goDetails(id) {
      if (this.cmsType == "post") {
        this.$router.push({
          path: "/new/details",
          query: {
            id: id
          }
        });
      }
      if (this.cmsType == "project") {
        this.$router.push({
          path: `/product/projectDetails`,
          query: {
            id: id
          }
        });
      }
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    getDate(time) {
      return publicChange.getDate(time);
    }
  }
};
</script>
<style scoped></style>
